<template>
    <div class="intro-box-scope">
        <el-dialog
            center
            custom-class="intro-box-scope-dialog"
            :title="intro_mission_text1"
            :visible.sync="dialogVisible"
            :before-close="close"
            width="400px">
           <div :class="shit$(`relative;`)">
                <div>
                    <el-carousel ref="carousel" @change="o => choose = o " height="266px" :autoplay="false" arrow="never" indicator-position="none" :loop="false" trigger="click" >
                        <el-carousel-item v-for="(item, index) in data.map(m => m.img)" :key="index">
                           <img :src="env$ + item" :class="shit$(`h:268px;`)" />
                        </el-carousel-item>
                    </el-carousel>
                    <div :class="shit$(`w:340px; h:128px; margin:auto; lh:1.57; mt:15px; mb:8px; font:14px; font-w:500; letter-s:1px;`)">
                        <p v-if="data[choose].content2" :class="shit$(data[choose].content2_shit)">{{ data[choose].content2 }}</p>
                        <p>{{ data[choose].content1 }}</p>
                    </div>
                </div>
                <div :class="shit$(`pb:15px; text-a:c;`)">
                    <template v-for="(item , i) in data.length" >
                        <span @click="$refs.carousel.setActiveItem(i)" :key="item" :class="[ shit$(`bgc:#d8d8d8; transition:.3s; w:7px; h:7px; radius:50%; dis:i-b; mr:3px; ml:3px; hover:bgc:#696969b3;`), choose === i && shit$(`bgc:#696969!;`) ]"></span>
                    </template>
                </div>
                <div @click="$refs.carousel.prev()" v-if="!(choose === 0)" :class="shit$(`w:35px; h:35px; radius:50%; bgc:#0ed3ff; absolute; top:173px; left: -17px; z:11; text-a:c; lh:2.2;`)">
                    <svg-icon href="#codelab-icon-prev" width="11" height="18" color="#ffffff"></svg-icon>
                </div>
                <div @click="$refs.carousel.next()" v-if="!(choose === data.length - 1)" :class="shit$(`w:35px; h:35px; radius:50%; bgc:#0ed3ff; absolute; top:173px; right: -17px; z:11; text-a:c; lh:2.2;`)">
                    <svg-icon href="#codelab-icon-next" width="11" height="18" color="#ffffff"></svg-icon>
                </div>
           </div>
        </el-dialog>

    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    data() {
      return {
        intro_mission_text1: this.$t("code-lab/component/intro/mission-repeat.vue_0"),
        dialogVisible: false,
        choose: 0,
        data: [
            { img: 'static/images/intro/intro-m-1.png', content1: this.$t("code-lab/component/intro/mission-repeat.vue_1") },
            { img: 'static/images/intro/intro-m-2.png', content1: this.$t("code-lab/component/intro/mission-repeat.vue_2") },
            { img: 'static/images/intro/intro-m-3.png', content1: this.$t("code-lab/component/intro/mission-repeat.vue_3"), content2_shit: 'c:#e44e4e;', content2: this.$t("code-lab/component/intro/mission-repeat.vue_4") },
        ]
      }
    },
    computed: {
        ...mapState(['env$']),
        ...mapState('introStore', [ 'showMissionIntro' ])
    },
    methods: {
        close (o) {
            this.$store.commit('introStore/upShowMissionIntro', [ false ])
            o()
        },
    },
    watch: {
        showMissionIntro (n) {
            this.dialogVisible = n
        },
    },
}
</script>

<style scope>
    .missionBox{
        position: fixed;
        z-index: 1999;
    }
    .block {
        width: 400px;
    }
</style>

<style lang="scss">
.intro-box-scope-dialog {
    border-radius: 24px;
    .el-dialog__title {
        width: 80%;
        margin: auto;
        display: block;
    }
    .el-dialog__header {
        border-top-left-radius: 24px;
        border-top-right-radius: 24px;
        background: #0ed3ff;
        font-size: 18px;
        color: #000;
        letter-spacing: 1px;
        padding: 20px 0px 10px;
    }
    .el-dialog__headerbtn .el-dialog__close {
        color: #000!important;
        margin-top: 4px;
    }
    .el-dialog__body {
        padding: 0px;
    }
    .el-dialog__footer {
        padding: 0px;
    }
}
.intro-box-scope {
    .el-dialog__wrapper {
        background-color: rgba(0, 0, 0, 0.1);
    }
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}

.el-carousel__indicators--outside button {
    background-color: #696969;
    opacity: .24;
    width: 7px;
    height: 7px;
    border-radius: 50%;
}
.el-carousel__indicator--horizontal {
    padding-top: 0px;
    padding-bottom: 0px;
}
.el-carousel__indicators--outside {
    margin-bottom: 15px;
}
}

</style>
